// extracted by mini-css-extract-plugin
export default {"root":"buttonsGroup_root__qw5Lh","isProfile":"buttonsGroup_isProfile__QD7i8","isCentered":"buttonsGroup_isCentered__8KHtH"};